// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._19pkxmi2{margin-top:var(--ds-space-negative-150,-9pt)}\n._glmpidpf>button{min-width:0}\n._ym62kb7n>button{flex-shrink:1}", ""]);
// Exports
module.exports = exports;
